import React from 'react';
import './Snackbar.css';

interface SnackbarProps {
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
  onClose: () => void;
  style?: React.CSSProperties;
}

const Snackbar: React.FC<SnackbarProps> = ({ message, type, onClose, style }) => {
  return (
    <div className={`snackbar snackbar-${type}`} style={style}>
      <div className="snackbar-content">
        <span className="snackbar-message">{message}</span>
        <button className="snackbar-close" onClick={onClose} aria-label="Close">
          ×
        </button>
      </div>
    </div>
  );
};

export default Snackbar;
